import { FaCircle, FaRegCircle } from 'react-icons/fa'
import s from './PriorityCellRenderer.scss'

const PriorityCellRenderer = ({ getPriorityColor, triggerPriorityPopover, data }) => {
  if (!data) return null

  return (
    <div className={s.popupContainer} id={`priority-${data.id}`}>
      {data.priority ? (
        <FaCircle
          className={s.priority}
          style={{ color: getPriorityColor(data.priority) }}
          onClick={() => {
            setTimeout(() => {
              triggerPriorityPopover(data.id)
            }, 500)
          }}
        />
      ) : (
        <FaRegCircle
          className={s.emptyPriority}
          onClick={() => {
            setTimeout(() => {
              triggerPriorityPopover(data.id)
            }, 500)
          }}
        />
      )}
    </div>
  )
}

export default PriorityCellRenderer
